import React from 'react';
import ButtonSquare from './BasicButton';

const textStyle = {
  fontFamily: 'Open Sans',
  fontSize: '14px',
  textTransform: 'uppercase',
  padding: '5px 15px',
  color: 'white',
  cursor: 'pointer',
  borderBottom: '1px',
};

const ButtonText = () => (
  <ButtonSquare link="">
    <input style={textStyle} type="submit" value="ENVOYER" />
  </ButtonSquare>

);

ButtonText.defaultProps = {
};

ButtonText.propTypes = {
};

export default ButtonText;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/ButtonSubmit.jsx